/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components';
import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';
import fonts from '@general/fonts';
import { Link as RouterLink } from 'react-router-dom';

export const BodyContainerStyled = styled.div`
    padding-bottom: 34px;
    padding-top: 34px;

    @media ${mediaQueries.smDown} {
        padding-bottom: 28px;
        padding-left: 24px;
        padding-right: 24px;
        padding-top: 28px;
    }
`;

export const BodyLarge = styled.p`
    color: ${colors.secondary};
    font-family: ${fonts.sans};
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.05px;
    line-height: 24px;
    margin: 0;

    @media ${mediaQueries.md} {
        font-size: 21px;
        font-weight: 400;
        line-height: 28px;
    }
`;

export const BodyMedium = styled.p`
    font-family: ${fonts.sans};
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.31px;
    line-height: 20px;
    margin: 0;

    @media ${mediaQueries.md} {
        font-size: 18px;
        font-weight: 400;
        line-height: 25px;
    }
`;

export const BodySmall = styled.p`
    font-family: ${fonts.sans};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.31px;
    line-height: 16px;
    margin: 0;

    @media ${mediaQueries.md} {
        font-size: 14px;
        line-height: 21px;
    }
`;

export const ButtonBase = styled.button`
    border: none;
    cursor: pointer;
    display: inline-block;
    font-family: ${fonts.sans};
    font-size: 14px;
    padding: 12px;
`;

export const Button = styled(ButtonBase)`
    background: ${colors.primary};
    border-radius: 3px;
    color: ${colors.white};
    font-weight: bold;
    line-height: 20px;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;

    &:hover {
        background: ${colors.primaryDark};
        color: ${colors.white};
    }
`;

export const ButtonOutlineRedesign = styled(ButtonBase)`
    background-color: transparent;
    border: 2px solid ${colors.primary};
    border-radius: 0;
    color: ${colors.primary};
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: ${fonts.sans};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.94px;
    line-height: 22px;
    padding: 0.8rem 3rem;
    text-transform: none;

    &:hover {
        background: ${colors.primaryDark};
        border-color: ${colors.primaryDark};
        color: ${colors.white};
    }

    &:disabled {
        opacity: 1;
    }

    &.isSubmitting {
        background-color: ${colors.disabled};
        color: #545454;
    }

    &.isSuccessful {
        background-color: ${colors.success};
        color: #fff;
    }

    &.isError {
        background-color: ${colors.error};
        color: #fff;
    }
`;

export const ButtonOutlineBase = styled(ButtonBase)`
    background-color: transparent;
    border: 2px solid ${colors.primary};
    border-radius: 0;
    color: ${colors.primary};
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: ${fonts.sans};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.94px;
    line-height: 22px;
    text-transform: none;
    transition: all 0.2s ease-in-out;

    &:hover {
        background: ${colors.primaryDark};
        border-color: ${colors.primaryDark};
        color: ${colors.white};
    }

    &:disabled {
        opacity: 1;
    }

    &.isSubmitting {
        background-color: ${colors.disabled};
        color: #545454;
    }

    &.isSuccessful {
        background-color: ${colors.success};
        color: #fff;
    }

    &.isError {
        background-color: ${colors.error};
        color: #fff;
    }
`;

export const ButtonOutlineLarge = styled(ButtonOutlineBase)`
    padding: 14px 53px;
`;

export const ButtonOutlineSmall = styled(ButtonOutlineBase)`
    display: inline-flex;
    height: 32px;
    padding: 5px 14px;
`;

export const ButtonRedesign = styled(Button)`
    border-radius: 0;
    font-weight: 500;
    height: 50px;
    padding-inline: 53px;
    text-transform: none;
`;

export const ButtonNoStyles = styled.button`
    background-color: transparent;
    cursor: pointer;
    padding: 0;
    margin: 0;
    font-size: 14px;
    border: none;
    font-family: ${fonts.sans};
`;

export const ButtonForIcon = styled.button`
    align-items: center;
    background-color: transparent;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 36px;
    justify-content: center;
    padding: 0;
    margin: 0;
    transition: background-color 0.2s ease-in-out;
    width: 36px;

    &:hover {
        background-color: ${colors.ultraLightGray};
    }

    @media ${mediaQueries.md} {
        height: 40px;
        width: 40px;
    }
`;

export const ButtonDashed = styled(ButtonBase)`
    border: 2px dashed ${colors.lightGray};
    background-color: #fff;
    &:hover {
        background-color: #eceeef;
    }
`;

export const ButtonLargeBase = styled.button`
    border: none;
    border-radius: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: ${fonts.sans};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.94px;
    line-height: 22px;
    padding: 14px 53px;
    text-transform: none;
    transition: all 0.2s ease-in-out;

    &[disabled] {
        cursor: not-allowed;
    }
`;

export const ButtonSmallBase = styled.button`
    border: none;
    border-radius: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: ${fonts.sans};
    font-size: 14px;
    font-weight: 500;
    height: 32px;
    letter-spacing: 0.94px;
    line-height: 22px;
    padding: 5px 14px;
    text-transform: none;
    transition: all 0.2s ease-in-out;

    &[disabled] {
        cursor: not-allowed;
    }
`;

export const ButtonPrimaryLarge = styled(ButtonLargeBase)`
    background-color: ${colors.primary};
    color: #fff;

    &:hover {
        background-color: ${colors.primaryDark};
    }

    &[disabled] {
        background-color: ${colors.ultraLightGray};
        color: ${colors.mediumGray};
    }

    &.isSubmitting {
        background-color: ${colors.disabled};
        color: #545454;
    }

    &.isSuccessful {
        background-color: ${colors.success};
        color: #fff;
    }

    &.isError {
        background-color: ${colors.error};
        color: #fff;
    }
`;

export const ButtonPrimarySmall = styled(ButtonSmallBase)`
    background-color: ${colors.primary};
    color: #fff;

    &:hover {
        background-color: ${colors.primaryDark};
    }

    &[disabled] {
        background-color: ${colors.ultraLightGray};
        color: ${colors.mediumGray};
    }

    &.isSubmitting {
        background-color: ${colors.disabled};
        color: #545454;
    }

    &.isSuccessful {
        background-color: ${colors.success};
        color: #fff;
    }

    &.isError {
        background-color: ${colors.error};
        color: #fff;
    }
`;

export const ButtonLightLarge = styled(ButtonLargeBase)`
    background-color: ${colors.ultraLightGray};
    color: ${colors.black};

    &:hover {
        background: ${colors.lightGray};
    }
`;

export const ButtonLightSmall = styled(ButtonSmallBase)`
    background-color: ${colors.ultraLightGray};
    color: ${colors.black};

    &:hover {
        background: ${colors.lightGray};
    }
`;

export const ButtonDarkLarge = styled(ButtonLargeBase)`
    background-color: ${colors.primaryDark};
    color: #fff;

    &.isSubmitting {
        background-color: ${colors.disabled};
        color: #545454;
    }

    &.isSuccessful {
        background-color: ${colors.success};
        color: #fff;
    }

    &.isError {
        background-color: ${colors.error};
        color: #fff;
    }
`;

export const ButtonLink = styled.a`
    align-items: center;
    background-color: ${colors.azure};
    border: none;
    border-radius: 0;
    color: #fff;
    cursor: pointer;
    display: flex;
    font-family: ${fonts.sans};
    font-size: 14px;
    font-weight: 500;
    justify-content: center;
    margin: 0 auto;
    max-width: 375px;
    padding: 1rem 3rem;
    text-align: center;
    text-decoration: none;
    text-transform: none;

    &:hover {
        background-color: ${colors.primaryDark};
        color: ${colors.white};
    }
`;

export const ChipBase = styled.div`
    align-items: center;
    border-radius: 38px;
    display: flex;
    flex-direction: row;
    font-family: ${fonts.sans};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    height: 31px;
    justify-content: center;
    left: 0px;
    letter-spacing: 0.5px;
    padding: 0px 20px;
    position: static;
    top: 0px;
`;

export const ChipButton = styled.button`
    align-items: center;
    background: ${colors.primary};
    border: none;
    border-radius: 38px;
    cursor: pointer;
    display: flex;
    height: 31px;
    justify-content: center;
    margin-bottom: 16px;
    margin-left: 8px;
    margin-right: 8px;
    padding: 0px 20px;
    width: 120px;

    &.active {
        background: ${colors.primaryDark};
    }

    &.disabled {
        background: ${colors.disabled};
    }
`;

export const ChipLightGray = styled(ChipBase)`
    background: ${colors.lightGray};
    color: ${colors.secondary};
`;

export const ChipButtonLightGray = styled.button`
    align-items: center;
    background: ${colors.ultraLightGray};
    border: none;
    border-radius: 38px;
    color: ${colors.azure};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    font-family: ${fonts.sans};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    height: 31px;
    justify-content: center;
    left: 0px;
    letter-spacing: 0.5px;
    padding: 0px 20px;
    position: static;
    top: 0px;
    margin-bottom: 0.5rem;
    margin-right: 0.5rem;

    &:focus {
        outline: none;
    }

    &:hover {
        background: ${colors.lightGray};
    }

    &.active {
        background: ${colors.azure};
        color: ${colors.white};
    }

    &.disabled {
        background: ${colors.ultraLightGray};
    }
`;

export const DivWithBgPatternWhite = styled.div`
    background-image: url(/assets/images/circle-pattern-gray.svg);
    background-size: cover;
`;

export const DivWithShadow = styled.div`
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.15);
`;

export const DivWithShadowAlternate = styled.div`
    box-shadow: 0px 0px 7px rgba(87, 87, 87, 0.2);
`;

export const DivWithShadowMediumUp = styled.div`
    @media ${mediaQueries.md} {
        box-shadow: 0px 0px 7px rgba(87, 87, 87, 0.2);
        padding: 32px;
    }
`;

export const PatternLightStyled = styled(DivWithBgPatternWhite)`
    padding: 30px 20px;
`;

export const ErrorText = styled.span`
    color: ${colors.error};
`;

export const FormSubheader = styled.h4`
    font-size: 1.25rem;
    line-height: 1.75rem;
    opacity: 0.9;
    margin: 2rem 0 1rem;
`;

export const Instructions = styled.p`
    color: rgba(0, 0, 0, 0.75);
    font-size: 0.9rem;
    line-height: 1.6875rem;
    opacity: 0.9;
    margin-top: 0.5rem;
`;

export const SmallInstructions = styled.p`
    color: ${props => (props.color ? props.color : css`rgba(0, 0, 0, 0.75)`)};
    font-size: 0.9rem;
    opacity: 0.9;
    margin-bottom: 0.5rem;
    line-height: 1.2rem;
`;

export const FormInput = styled.input`
    border: 1px solid ${colors.lightGray};
    display: inline-block;
    font-family: ${fonts.sans};
    padding: 4px 8px;
    width: 250px;
`;

export const FormLabel = styled.span`
    display: block;

    @media ${mediaQueries.md} {
        display: inline-block;
        width: 200px;
    }
`;

export const RadioInput = styled.input`
    border: 1px solid ${colors.lightGray};
    margin-right: 2rem;
`;

export const H1 = styled.h1`
    color: ${colors.primary};
    font-family: ${fonts.sans};
    font-size: 42px;
    font-style: normal;
    font-weight: 900;
    letter-spacing: 1.96px;
    line-height: 42px;

    @media ${mediaQueries.md} {
        font-size: 55px;
        line-height: 70px;
    }
`;

export const H2 = styled.h2`
    font-family: ${fonts.sans};
    font-size: 28px;
    font-style: normal;
    font-weight: 900;
    letter-spacing: 1px;
    line-height: 28px;

    @media ${mediaQueries.md} {
        font-size: 39px;
        font-weight: 700;
        letter-spacing: 1.39px;
        line-height: 50px;
    }
`;

export const H3 = styled.h3`
    font-family: ${fonts.sans};
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0.5px;
    line-height: 22px;
    margin: 0;
    word-break: break-word;

    @media ${mediaQueries.md} {
        font-size: 35px;
        line-height: 55px;
    }
`;

export const H4 = styled.h4`
    color: ${colors.secondary};
    font-family: ${fonts.sans};
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0.86px;
    line-height: 29px;
    margin: 0;
    word-break: break-word;

    @media ${mediaQueries.md} {
        font-size: 24px;
        line-height: 29px;
    }
`;

export const H5 = styled.h5`
    color: ${colors.secondary};
    font-family: ${fonts.sans};
    font-size: 18px;
    font-style: normal;
    font-weight: 900;
    letter-spacing: 0.64px;
    line-height: 22px;
    margin: 0;

    @media ${mediaQueries.md} {
        font-size: 18px;
        line-height: 22px;
    }
`;

export const DividerLightGreyStyled = styled.hr`
    border-top: 1px solid ${colors.lightGray};
    width: 100%;
`;

export const DividerBlueStyled = styled.hr`
    border-color: ${colors.azure};
    border-top-width: 2px;
`;

export const ImageCover = styled.img`
    max-width: 100%;
    object-fit: cover;
`;

export const Input = styled.input`
    border: 1px solid ${colors.lightGray};
    display: inline-block;
    font-family: ${fonts.sans};
    padding: 4px 8px;
`;

export const Label = styled.label`
    margin-bottom: 0;
`;

export const LabelSmall = styled.span`
    color: ${colors.background};
    font-family: ${fonts.sans};
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.3px;
    line-height: 12px;

    @media ${mediaQueries.md} {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0.5px;
        line-height: 14px;
    }
`;

export const LabelLarge = styled.span`
    font-family: ${fonts.sans};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0.3px;
    line-height: 16px;

    @media ${mediaQueries.md} {
        font-size: 14px;
        line-height: 18px;
    }
`;

export const LinkBase = styled.a`
    border-bottom: 1px solid transparent;
    color: ${colors.link} !important; // Added !important to override a:not([href]):not([tabindex]) in /assets/css/style.css
    cursor: pointer;
    font-family: ${fonts.sans};
    font-style: normal;
    font-weight: 500;
    transition: border-color 0.2s ease-in-out;

    &:hover {
        border-color: ${colors.azureTint};
    }
`;

export const LinkLarge = styled(LinkBase)`
    font-size: 18px;
    letter-spacing: 0.31px;
    line-height: 25px;
`;

export const LinkMedium = styled(LinkBase)`
    font-size: 16px;
    letter-spacing: 0.31px;
    line-height: 22px;
`;

export const LinkSmall = styled(LinkBase)`
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.3px;
    line-height: 18px;

    @media ${mediaQueries.md} {
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.94px;
        line-height: 22px;
    }
`;

export const LinkRouter = styled(RouterLink)`
    border-bottom: 1px solid transparent;
    color: ${colors.link} !important;
    cursor: pointer;
    font-family: ${fonts.sans};
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.3px;
    line-height: 18px;
    transition: border-color 0.2s ease-in-out;

    @media ${mediaQueries.md} {
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.94px;
        line-height: 22px;
    }

    &:hover {
        border-color: ${colors.azureTint};
    }
`;

export const LinkText = styled.span`
    color: ${colors.secondary};
    font-family: ${fonts.sans};
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.3px;
    line-height: 18px;

    @media ${mediaQueries.md} {
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.94px;
        line-height: 22px;
    }
`;

export const LinkTextDisabled = styled.span`
    color: grey;
    font-family: ${fonts.sans};
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.3px;
    line-height: 18px;

    @media ${mediaQueries.md} {
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.94px;
        line-height: 22px;
    }
`;

export const P = styled.p`
    font-size: 1rem;
    line-height: normal;
`;

export const PhotoUploadWrapper = styled.div`
    max-width: 356px;
    aspect-ratio: 16/9;
    position: relative;
`;

export const ResponsiveBlock = styled.div`
    display: block;

    @media ${mediaQueries.md} {
        display: inline-block;
    }
`;

export const Tag = styled.span`
    align-items: center;
    border-radius: 38px;
    display: flex;
    font-family: ${fonts.sans};
    font-size: 12px;
    font-style: normal;
    font-weight: normal;
    height: 24px;
    justify-content: center;
    letter-spacing: 0.5px;
    line-height: 14px;
    padding: 0 20px;
`;

export const TagPrimary = styled(Tag)`
    background-color: ${colors.brightSunTint};
`;

export const TagSecondary = styled(Tag)`
    font-size: 0.85rem;
    background-color: ${colors.brightSun};
    padding: 0.9rem 1.2rem;
`;

export const Textarea = styled.textarea`
    border: 1px solid ${colors.lightGray};
    border-radius: 0;
    font-family: ${fonts.sans};
    font-size: 18px;
    height: 147px;
    letter-spacing: 0.31px;
    line-height: 25px;
    padding: 15px 20px;
    resize: none;
    width: 100%;
`;

export const Textbox = styled.input`
    border: 2px solid #e4eaef;
    border-radius: 0;
    color: #000;
    font-family: 'Red Hat Display', sans-serif;
    font-size: 1rem;
    line-height: 1.75rem;
    padding: 0 0.75rem;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    width: 100%;

    &[disabled] {
        background-color: ${colors.ultraLightGray};
        color: ${colors.mediumGray};
    }

    @media ${mediaQueries.md} {
        font-size: 1.25rem;
        padding: 1rem 1.25rem;
    }
`;

export const Ul = styled.ul`
    list-style-type: none;
    margin: 0;
    padding: 0;
`;

export const LoadingContainer = styled.div`
    align-items: center;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    left: 0;
    min-height: ${props => props.minHeightMobile}px;
    text-align: center;
    top: 0;
    width: 100%;
    z-index: 99999;
    @media ${mediaQueries.lg} {
        min-height: ${props => props.minHeight}px;
    }
`;

export const LoadingIcon = styled.div`
    background: #ffffff url('/assets/images/loading.gif') no-repeat center center;
    background-size: 100% 100%;
    border: 1px solid #888;
    border-radius: 5px;
    height: 50px;
    padding: 10px;
    width: 50px;
`;

export const SectionWrapperInner = styled.div`
    padding-left: 1rem !important;
    padding-right: 1rem !important;

    @media ${mediaQueries.md} {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
`;

export const SectionWrapperOuter = styled.div`
    padding: 2rem 0.5rem !important;

    @media ${mediaQueries.lg} {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    @media ${mediaQueries.xl} {
        padding-left: 2rem !important;
        padding-right: 2rem !important;
    }
`;

export const RefinementContainer = styled.div`
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    width: 100% !important;

    @media ${mediaQueries.md} {
        width: 340px !important;
    }

    @media ${mediaQueries.lg} {
        width: 280px !important;
    }

    @media ${mediaQueries.xl} {
        width: 215px !important;
    }

    &.isOpen {
        z-index: 200;
    }

    &:not(:last-of-type) {
        margin-right: 1rem;
    }
`;
